export default "__VITE_ASSET__XlgCb7v$__"